export default "__VITE_ASSET__BdAFQlsv__"